import { FC, useState } from 'react';
import { Box, Heading, Input } from '@chakra-ui/react';

export const InputToggler: FC<{
  placeholder: string;
  inputValue: string;
  onInputChange: (value: string) => void;
  alwaysHideInput?: boolean;
  isInvalid?: boolean;
}> = ({
  placeholder,
  inputValue,
  onInputChange,
  alwaysHideInput,
  isInvalid = false,
}) => {
  const [isHeadingShown, setIsHeadingShown] = useState(false);

  return (
    <Box>
      {(isHeadingShown || alwaysHideInput) && !isInvalid ? (
        <Heading
          color="custom_blue.1"
          fontSize="2xl"
          onClick={() => setIsHeadingShown(false)}
        >
          {inputValue ? inputValue : placeholder}
        </Heading>
      ) : (
        <Input
          isInvalid={isInvalid}
          value={inputValue}
          fontSize="xl"
          placeholder={placeholder}
          onChange={e => onInputChange(e.target.value)}
          onMouseLeave={() => setIsHeadingShown(true)}
        />
      )}
    </Box>
  );
};
